<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <!-- :headtitle="'Gross sales by ' + $setNameManagerSupervisor()" -->
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row
            dense
            no-gutters
            class="mb-5 text-center text-md-left subtitle-1"
          >
            <v-col cols="12" lg="3">
              Total gross sales:
              <v-avatar :size="$gold_coin_sm"
                ><img :src="$goldCoinWhite" alt="coin"
              /></v-avatar>
              <strong>{{ totalCommission | toNumberWithDecimal }}</strong>
            </v-col>
          </v-row>
          <v-row dense class="d-flex justify-end mt-n2">

            <v-col cols="12" lg="2" class="span-label">
              <span>Sales type</span>
              <v-select class="regular-field" :items="status" item-text="text" item-value="value" v-model="filter.status" label="Sales type"></v-select>
            </v-col>

            <v-col cols="12" lg="2" class="span-label" :class="($hideifuserisSupervisor())">
              <!-- <span v-html="$setNameManagerSupervisor()"></span> -->
              <span>Agent</span>
              <agent-credit-autocomplete-template level="2"
                ref="agent_autocomplete"
              ></agent-credit-autocomplete-template>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span class="control-label">Dates</span>
              <v-dialog
                ref="dialog"
                v-model="filter_datedialog"
                :return-value.sync="filter.daterange"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="regular-field"
                    hide-details
                    dense
                    v-model="filter.daterange"
                    label="Dates"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.daterange" scrollable range>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="red_button"
                    @click="filter_datedialog = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="green_button"
                    @click="$refs.dialog.save(filter.daterange)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </v-col>

            <!-- <v-col cols="12" lg="3">
              <v-text-field
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search any keyword"
                hide-details
              ></v-text-field>
            </v-col> -->

            <v-col cols="12" lg="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.level`]="{ item }">{{
                  "L" + item.level
                }}</template>
                
                <template v-slot:[`item.totalsales`]="{ item }"
                  ><v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{
                    item.totalsales == null
                      ? 0.0
                      : item.totalsales | toNumberWithDecimal
                  }}</template
                >
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  data() {
    return {
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          sortable: true,
          searchable: false,
          align: " d-none",
        },
        {
          text: "Agent",
          value: "manager",
          name: "manager",
          sortable: false,
          searchable: true,
        },
        {
          text: "Level",
          value: "level",
          name: "level",
          sortable: false,
          searchable: true,
        },
        // {
        //   text: "GM sales",
        //   value: "totalgmsales",
        //   name: "totalgmsales",
        //   sortable: false,
        //   searchable: false,
        // },
        {
          text: "Total gross sales",
          value: "totalsales",
          name: "totalsales",
          sortable: false,
          searchable: false,
        },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_searchAgent: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",

      totalCommission: 0,
      previousWeek: 0,
      currentWeek: 0,
      daily: 0,

      form: new this.$Form({
        id: "",
        name: "",
        username: "",
        email: "",
        password: "",
        roles: {},
        user_status: 1,
      }),

      filter: {
        // date: this.$moment().format("YYYY-MM-DD"),
        datefrom: null,
        dateto: null,
        draw: [],
        daterange: [
          this.$moment().format("YYYY-MM-DD"),
          this.$moment().format("YYYY-MM-DD"),
        ],
        status: 'individual',
      },
      filter_datedialog: null,
      drawlist: [],
      status: [
        { text: "All gross", value: "all" },
        { text: "Individual gross", value: "individual" },
      ],
    };
  },
  methods: {
    paramsfilter() {
      let from,
        to = "";

      let subagent =
        this.$store.state.currentUser.agent_data.level != 0
          ? this.$store.state.currentUser.agent_data.id
          : null;
      try {
        if (this.$refs.agent_autocomplete.autocomplete_model.id) {
          subagent = this.$refs.agent_autocomplete.autocomplete_model.id;
        }
      } catch (error) {
        subagent =
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null;
      }

      if (this.filter.daterange) {
        from = this.$moment(this.filter.daterange[0]).format("YYYY-MM-DD");
        to = this.$moment(this.filter.daterange[1]).format("YYYY-MM-DD");
      }

      return {
        ...this.dt_options,
        query: this.dt_searchQuery,
        draw: this.filter.draw.join(","),
        filterDateFrom: from,
        filterDateTo: to,
        agent_id: subagent,
        reload: this.dt_reload,
        level: 2,
        status: this.filter.status,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      // let apiPath = (await this.$_CONFIG.api()) + "/grossbymanager";
      let apiPath = (await this.$_CONFIG.api()) + "/grossbyagent";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.totalCommission = res.data.totalCommission;

          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log("Error searching");
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    getdrawlist() {
      this.$axios
        .get(this.$_CONFIG.api("API_DRAW_DROPDOWN"))
        .then((res) => {
          this.drawlist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getdrawlist();
    this.getDataFromApi();
  },
  mounted() {
    // console.log(this.$moment().format("YYYY-MM-DD"))
  },
};
</script>
<style scoped></style>